module.exports = __webpack_public_path__ + "static/media/dj.a77a7f76.svg";